import { svg } from 'utils/imgList';
import { ItemNav } from 'types/itemNavBar';
import { listRoutes } from 'router/listRoutes';

export const optionsNav: ItemNav[] = [
	{
		id: 0,
		isOpen: false,
		name: 'navBarOptions.users',
		isSubOptions: false,
		isALink: true,
		slug: listRoutes.users,
		roleItem: [0, 1, 2, 4, 5],
		icon: svg.user,
		isExternaLink: false,
		tagNew: false,
		finalDateTagNew: null
	},
	{
		id: 1,
		isOpen: false,
		name: 'navBarOptions.dynamicPages',
		isSubOptions: false,
		slug: listRoutes.dynamicPages,
		isALink: true,
		roleItem: [0, 1, 2, 3, 4],
		icon: svg.phone,
		isExternaLink: false,
		tagNew: false,
		finalDateTagNew: null
	},
	// {
	// 	id: 2,
	// 	isOpen: false,
	// 	name: 'Etiquetas promocionais',
	// 	isSubOptions: false,
	// 	slug: listRoutes.priceTag,
	// 	isALink: true,
	// 	roleItem: [0, 1, 2, 3, 4],
	// 	icon: svg.priceTag,
	// 	isExternaLink: false,
	// 	tagNew: false,
	// 	finalDateTagNew: null
	// },
	// {
	// 	id: 2,
	// 	isOpen: false,
	// 	name: 'navBarOptions.menuElements',
	// 	isSubOptions: false,
	// 	slug: listRoutes.menuItens,
	// 	isALink: true,
	// 	roleItem: [0, 1, 2, 3, 4],
	// 	icon: svg.menu,
	// 	isExternaLink: false,
	// 	tagNew: false,
	// 	finalDateTagNew: null
	// },
	// {
	// 	id: 3,
	// 	isOpen: false,
	// 	name: 'navBarOptions.localToItensMenu',
	// 	isSubOptions: false,
	// 	isALink: true,
	// 	slug: listRoutes.menuItensLocation,
	// 	roleItem: [0, 1, 2, 3, 4],
	// 	icon: svg.file,
	// 	isExternaLink: false,
	// 	tagNew: false,
	// 	finalDateTagNew: null
	// },
	{
		id: 8,
		isOpen: false,
		name: 'Telas',
		isSubOptions: true,
		isALink: true,
		slug: listRoutes.menuItensLocation,
		roleItem: [0, 1, 2, 3, 4],
		icon: svg.screens,
		isExternaLink: false,
		tagNew: false,
		finalDateTagNew: null,
		subOptions: [
			{
				isSelected: true, //se esta selecionado ou não
				name: 'Estáticos', //nome q aparece no dashboard
				slug: listRoutes.screens.static, //rota
				roleSubitem: [0, 1, 2, 3, 4], //tipos dos usuários que podem acessar essa rota
				isExternaSublLink: false, //se for um link fora do novo dashboard
				tagNew: false, //mostra a tag new em cima da opção
				finalDateTagNew: null //se for uma string, depois dessa data a tag não será mais mostrada
			},
			{
				isSelected: true, //se esta selecionado ou não
				name: 'Treinamentos', //nome q aparece no dashboard
				slug: listRoutes.screens.trainings, //rota
				roleSubitem: [0, 1, 2, 3, 4], //tipos dos usuários que podem acessar essa rota
				isExternaSublLink: false, //se for um link fora do novo dashboard
				tagNew: false, //mostra a tag new em cima da opção
				finalDateTagNew: null //se for uma string, depois dessa data a tag não será mais mostrada
			},
			{
				isSelected: true, //se esta selecionado ou não
				name: 'Blog', //nome q aparece no dashboard
				slug: listRoutes.screens.blog, //rota
				roleSubitem: [0, 1, 2, 3, 4], //tipos dos usuários que podem acessar essa rota
				isExternaSublLink: false, //se for um link fora do novo dashboard
				tagNew: false, //mostra a tag new em cima da opção
				finalDateTagNew: null //se for uma string, depois dessa data a tag não será mais mostrada
			}
		]
	},
	// {
	// 	id: 4,
	// 	isOpen: false,
	// 	name: 'navBarOptions.dynamicShowcase',
	// 	isSubOptions: false,
	// 	isALink: true,
	// 	slug: listRoutes.dynamicShowCase,
	// 	roleItem: [0, 1, 2, 3, 4],
	// 	icon: svg.showcase,
	// 	isExternaLink: false,
	// 	tagNew: false,
	// 	finalDateTagNew: null
	// },
	// {
	// 	id: 5,
	// 	isOpen: false,
	// 	name: 'navBarOptions.coupuns',
	// 	isSubOptions: false,
	// 	slug: listRoutes.coupons,
	// 	isALink: true,
	// 	roleItem: [0, 1, 2, 3, 4],
	// 	icon: svg.coin,
	// 	isExternaLink: false,
	// 	tagNew: false,
	// 	finalDateTagNew: null
	// },
	// {
	// 	id: 6,
	// 	isOpen: false,
	// 	name: 'navBarOptions.settings',
	// 	isSubOptions: false,
	// 	slug: listRoutes.settings,
	// 	isALink: true,
	// 	roleItem: [0, 1, 2, 3, 4],
	// 	icon: navBarImages.config,
	// 	isExternaLink: false,
	// 	tagNew: false,
	// 	finalDateTagNew: ''
	// },
	{
		id: 9,
		isOpen: false,
		name: 'Listas',
		isSubOptions: true,
		isALink: true,
		roleItem: [0, 1, 2, 3, 4],
		icon: svg.listGrid,
		isExternaLink: false,
		tagNew: false,
		finalDateTagNew: null,
		subOptions: [
			{
				isSelected: true, //se esta selecionado ou não
				name: 'Logos', //nome q aparece no dashboard
				slug: listRoutes.brandList.logos, //rota
				roleSubitem: [0, 1, 2, 3, 4], //tipos dos usuários que podem acessar essa rota
				isExternaSublLink: false, //se for um link fora do novo dashboard
				tagNew: false, //mostra a tag new em cima da opção
				finalDateTagNew: null //se for uma string, depois dessa data a tag não será mais mostrada
			},
			{
				isSelected: true, //se esta selecionado ou não
				name: 'Banners de marcas', //nome q aparece no dashboard
				slug: listRoutes.brandList.brandBanners, //rota
				roleSubitem: [0, 1, 2, 3, 4], //tipos dos usuários que podem acessar essa rota
				isExternaSublLink: false, //se for um link fora do novo dashboard
				tagNew: false, //mostra a tag new em cima da opção
				finalDateTagNew: null //se for uma string, depois dessa data a tag não será mais mostrada
			},
			{
				isSelected: true, //se esta selecionado ou não
				name: 'Banners PLP', //nome q aparece no dashboard
				slug: listRoutes.brandList.plpBanners, //rota
				roleSubitem: [0, 1, 2, 3, 4], //tipos dos usuários que podem acessar essa rota
				isExternaSublLink: false, //se for um link fora do novo dashboard
				tagNew: false, //mostra a tag new em cima da opção
				finalDateTagNew: null //se for uma string, depois dessa data a tag não será mais mostrada
			},
			{
				isSelected: true, //se esta selecionado ou não
				name: 'Banner PopUp', //nome q aparece no dashboard
				slug: listRoutes.bannerPopup, //rota
				roleSubitem: [0, 1, 2, 3, 4], //tipos dos usuários que podem acessar essa rota
				isExternaSublLink: false, //se for um link fora do novo dashboard
				tagNew: false, //mostra a tag new em cima da opção
				finalDateTagNew: null //se for uma string, depois dessa data a tag não será mais mostrada
			}
		]
	},
	// {
	// 	id: 10,
	// 	isOpen: false,
	// 	name: 'Vitrine dinâmica',
	// 	isSubOptions: false,
	// 	slug: listRoutes.showcase,
	// 	isALink: true,
	// 	roleItem: [0, 1, 2, 3, 4],
	// 	icon: svg.carrinho,
	// 	isExternaLink: false,
	// 	tagNew: false,
	// 	finalDateTagNew: null
	// },
	{
		id: 11,
		isOpen: false,
		name: 'navBarOptions.adminPainel',
		isSubOptions: false,
		isALink: true,
		slug: listRoutes.admPainel,
		roleItem: [0, 1, 2, 3, 4],
		icon: svg.shieldCheck,
		isExternaLink: false,
		tagNew: false,
		finalDateTagNew: ''
	},
	{
		id: 12,
		isOpen: false,
		name: 'Contato',
		isSubOptions: false,
		isALink: true,
		slug: listRoutes.contact,
		roleItem: [0, 1, 2, 3, 4],
		icon: svg.contact,
		isExternaLink: false,
		tagNew: false,
		finalDateTagNew: null
	}
];
